
        import * as riot from 'riot'
        import App from './index.tag'

        import $ from "jquery";
        window.$ = window.jQuery = $;

        document.addEventListener("DOMContentLoaded", () => {
            const mountApp = riot.component(App);
            mountApp(document.getElementById('root'))
        });
    